const state = {
    route: '/register/form',
}
const mutations = {
    SET_ROUTE(state, route) {
        state.route = route
    }
}

export default {
    namespaced: true,
    state,
    mutations,
}
